<template>
  <div class="page-content">
    <!-- {{ model.title }} -->
    <div v-html="model.content" class="con"></div>
  </div>
</template>

<script>
import { getZhongxinZhize } from "@/apis/zuzhijiagou";
export default {
  data() {
    return {
      model: {},
    };
  },
  created() {
    this.getZhongxinZhize();
  },
  methods: {
    async getZhongxinZhize() {
      const { data } = await getZhongxinZhize();
      this.model = data || [];
    },
  },
};
</script>

<style lang="scss" scoped>
.page-content {
  // display: flex;
  .con {
    display: block;
  }
}
</style>
